module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-transition-link/gatsby-browser.js'),
      options: {"plugins":[],"layout":"/Users/joellopez/Documents/Personal/carpeta sin título/LASFLORESPROPIEDADES1/src/layout/index.js"},
    }]
